import { render } from "./App.vue?vue&type=template&id=6eb6a8d3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6eb6a8d3&lang=scss"

import exportComponent from "/Applications/phpstudy/bjhy/t.sz.edu-xr-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__